import { render } from "./ExampleDeviceScreenMenu.vue?vue&type=template&id=14d05ed4&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenMenu.vue?vue&type=style&index=0&id=14d05ed4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d05ed4"]])

export default __exports__